<style lang="less" scoped>
.table-bar {
  display: flex;
  width: 100%;
  align-items: center;
  &__tabs {
    overflow-y: auto;
    width: 50%;
  }
  &__button-group {
    flex: 1;
    border-bottom: 2px solid #e4e7ed;
    padding-bottom: 10px;
    padding-left: 40px;
    display: flex;
    justify-content: flex-end;
    overflow-y: auto;
    height: 37px;
  }
}
/deep/ .el-tabs__header {
  margin: 0px;
  margin-bottom: 1px;
}
/deep/ .el-tabs__item {
  height: 49px;
  line-height: 40px;
}
</style>

<template>
  <sz-card>
    <div class="table-bar">
      <div class="table-bar__tabs">
        <el-tabs :model-value="modelValue" @tab-click="(tab) => handleClick(tab)">
          <el-tab-pane v-for="(tab, key) in tabs" :key="key" :label="tab.label + `(${count[tab.name] || ' 0 '})`" :name="tab.id">
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="table-bar__button-group">
        <slot name="customButtons" />
        <el-button v-for="(button, key) in buttonGroup" :key="key" :size="'small'" :plain="button.plain" :circle="button.circle" :loading="loading ? loading : button.loading" :disabled="button.disabled" :type="button.type" :icon="button.icon" :style="button.style" @click="button.event && $emit(button.event, button)">{{ button.name }}</el-button>
      </div>
    </div>
    <slot name="table"></slot>
  </sz-card>
</template>

<script lang="ts">
import { defineComponent, PropType, readonly, computed, ref, Ref } from "vue";
export default defineComponent({
  props: {
    /**
     * @param {Array} buttonGroup 按钮组信息
     */
    buttonGroup: {
      type: Array as PropType<any[]>,
      default: (): any[] => [],
    },

    /**
     * @param {Array} tabs 选项卡列表
     */
    tabs: {
      type: Array as PropType<any[]>,
      default: (): any[] => [],
    },

    /**
     * @param {Boolean} loading 加载状态
     */
    loading: {
      type: Boolean,
      default: false,
    },

    /**
     * @param {Boolean} count 计数信息
     */
    count: {
      type: Object,
      default: (): any => {
        return {};
      },
    },

    /**
     *@param name值
     */
    modelValue: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleClick(tab: any) {
      this.$emit("update:modelValue", tab.props.name);
      this.$emit("handleClick");
    },
  },
});
</script>
